import { initContract } from "@ts-rest/core";
import {
  CreatedDepartment,
  ManyCreatedDepartments,
  upsertDepartmentInput,
} from "../validators/departments.validator";
import { z } from "zod";

const c = initContract();

export const departmentContract = c.router({
  getDepartments: {
    method: "GET",
    path: "/departments",
    responses: {
      200: c.type<ManyCreatedDepartments>(),
    },
  },
  upsertDepartment: {
    method: "PUT",
    path: "/departments",
    body: upsertDepartmentInput,
    responses: {
      200: c.type<CreatedDepartment>(),
    },
  },
  deleteDepartment: {
    method: "DELETE",
    path: "/departments/:id",
    body: z.void(),
    responses: {
      204: c.type<void>(),
    },
  },
});
